import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import { ReactComponent as Check } from '../../Img/icon-check.svg';
import {NotificationManager} from 'react-notifications';

const UploadTamponSignature = (props) =>
{
    const green = '#59B44A';
    const purple = '#6571FE';
    
    const [tampon, setTampon] = useState(null);
    const [organisme, setOrganisme] = useState(null);
    const [aff, setAff] = useState(false);

    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            // Stocke l'image sous forme de base64 pour prévisualisation
            const reader = new FileReader();
            reader.onload = (e) => {
                setTampon(e.target.result);
            };
            reader.readAsDataURL(file);
            await setAff(!aff);
        }
    };

    const handleDrop = async (event) => {
        event.preventDefault();
        const file = event.dataTransfer?.files && event.dataTransfer.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => setTampon(e.target.result);
            reader.readAsDataURL(file);
            setAff(!aff);
        }
    };

    async function mount()
    {    
        const params = {
            'getOrganismes': true,
            'id': props.user.id_organisme
        }
        await axios.post('https://app-slfinance.fr/api/organismes.php', qs.stringify(params))
        .then(async (res) => {
            const data0 = res?.data && res.data[0] ? res.data[0] : null;
            if (data0) {
                const rawTampon = data0.tampon_signature;
                if (rawTampon && typeof rawTampon === 'string' && rawTampon.length > 8) {
                    setTampon(rawTampon);
                }
                else {
                    setTampon(null);
                }
                setOrganisme(data0);
            }
            else {
                setTampon(null);
                setOrganisme(null);
            }
        })
        .catch((err) => {
            console.warn(err)
        })
    }


    useEffect(() => {
        mount();
    }, [])


    async function validation()
    {
        if (tampon !== null && organisme !== null)
        {
            const params = {
                'updateOrganisme': true,
                'id': organisme.id,
                'tampon_signature': tampon
            }
            await axios.post('https://app-slfinance.fr/api/organismes.php', qs.stringify(params))
            .then(async (res) => {
                if (res.data['status'] === 1) {
                    NotificationManager.success(res.data['status_message'], '', 2000);
                }
                else {
                    NotificationManager.warning(res.data['status_message'], '', 5000);
                }
            })
            .catch((err) => {
                console.warn(err)
            })
        }
    }
    

    return (
        <div className='shadow-xl' style={{width: '90%', borderRadius: 10, padding: 18, margin: '8px auto', backgroundColor: 'white', boxShadow: '0 8px 30px rgba(0,0,0,0.06)'}}>
            <div style={{display: 'flex', flexDirection: 'column', gap: 12}}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <div style={{flex: 1}}></div>
                    <p style={{flex: 1, fontWeight: 'bold', textAlign: 'left'}}>Tampon de signature</p>
                    <div style={{fontSize: 13, color: '#666'}}>Format PNG/JPG recommandé</div>
                </div>

                <input
                    id="upload-tampon-input"
                    type="file"
                    accept="image/png, image/jpeg"
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                />

                <div style={{display: 'flex', gap: 18, alignItems: 'center', flexWrap: 'wrap'}}>
                    <div
                        onDrop={handleDrop}
                        onDragOver={(e) => e.preventDefault()}
                        onClick={() => document.getElementById('upload-tampon-input').click()}
                        role="button"
                        style={{
                            flex: '0 0 320px',
                            height: 180,
                            borderRadius: 8,
                            border: '2px dashed #E6E9F2',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            backgroundColor: '#FBFBFE'
                        }}
                    >
                        {tampon ? (
                            <img alt="aperçu tampon" src={tampon} style={{maxWidth: '100%', maxHeight: '100%', borderRadius: 6}} />
                        ) : (
                            <div style={{textAlign: 'center', color: '#7A7D9A'}}>
                                <div style={{fontWeight: 600, marginBottom: 6}}>Cliquez ou glissez une image</div>
                                <div style={{fontSize: 13}}>PNG ou JPG • Taille recommandée</div>
                            </div>
                        )}
                    </div>

                    <div style={{flex: 1, minWidth: 220, display: 'flex', flexDirection: 'column', gap: 8}}>

                        <div style={{display: 'flex', gap: 8, marginTop: 12}}>
                            <button
                                onClick={() => document.getElementById('upload-tampon-input').click()}
                                style={{flex: 1, padding: '10px 12px', borderRadius: 8, border: '1px solid #E9ECEF', background: 'white', cursor: 'pointer'}}
                            >
                                Choisir un fichier
                            </button>
                        </div>

                        {(props.user.id_type_users == '1' || props.user.id_type_users == '2') &&
                        <div style={{display: 'flex', gap: 8, marginTop: 6}}>
                            <button
                                onClick={() => validation()}
                                style={{flex: 1, padding: '10px 12px', borderRadius: 8, border: 'none', background: green, color: 'white', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8}}
                            >
                                <Check width="14" />
                                Valider
                            </button>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UploadTamponSignature;
